import axiosInstance from '../utils/axios';

const calibrationPolicyService = {
  getPolicy: async () => {
    const response = await axiosInstance.get('/settings/calibration-policy');
    if (response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data.message || '보정 정책 정보를 불러오는데 실패했습니다.');
  },

  updatePolicy: async (dailyMax, totalMax) => {
    const response = await axiosInstance.put('/settings/calibration-policy', {
      daily_max: dailyMax,
      total_max: totalMax,
    });
    if (response.data.success) {
      return { success: true, message: '보정 횟수 정책이 성공적으로 변경되었습니다.' };
    }
    throw new Error(response.data.message || '보정 정책 변경에 실패했습니다.');
  },
};

export default calibrationPolicyService;
